export const windowParams = new URL(document.location).searchParams;

export function processCompanySearchParams(params) {
  const requestParams = new URLSearchParams(params);
  if (windowParams && requestParams) {
    requestParams.forEach((v, k) => {
      // We don't need facets param since they are in ap config.
      if (k !== 'facets') windowParams.set(k, v);
    });
  }
  return windowParams;
}

export function addSingleParam(param) {
  windowParams.set(param.name, param.value);
  return windowParams;
}

export function addMultipleParams(params) {
  params.forEach((param) => addSingleParam(param));
  return windowParams;
}
